export const tokenResult = {
  access_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJyZjZZMk1JdjhjRER0NHVPay1tVEpfakpSMDdmS2NvSlNhREZqdEd1NzlZIn0.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.HEzWj-IRZYi2WVMIAgQV8RgFV7FwKYu-lFpKl3kCTpDx-ATzGOj3IDN9qPZnF4U81USzHe4aXNHSa9y8xOu-h2M0d0jkjt-7UkOaQfxouCTBK5MM7PA13ZnyHi-H_YNmDEcf2r2bX_sci7-pdEIoE942Cef9gcaf9rRxlmJUcc5_iCM5I35_6vm39M6bRD8YhMZeVydwLNiGMaSSIMRACjCbH4NC5HpKIiu0eDhVUFgwqMs0UHgtLqekgU09LBqdep7TZ7JKKctWl2plAzrmXqQRMx84a-vHQmKeP18Gq5LED5t9S4Mpu3mAgXheo2n9Q8pGaf_qCVJeO8ScEjI6yg',
  expires_in: 1800,
  refresh_expires_in: 31535506,
  refresh_token:
    'eyJhbGciOiJIUzUxMiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICI5ZWMzZGUwOC02ZjA2LTRlMGUtYTk0YS05YjVjMzZhMWZiNTAifQ.eyJleHAiOjE3Nzk4ODQwMTQsImlhdCI6MTc0ODM0ODUwOCwianRpIjoiZDgwNzIwZjktM2FiMC00NTcyLWJhMDYtOGRhMmJkNTczYTM5IiwiaXNzIjoiaHR0cHM6Ly9pZC5hdS50ZXN0LnRvbXJhLmNsb3VkL2F1dGgvcmVhbG1zL1RvbXJhQ29ubmVjdFVzZXJzIiwiYXVkIjoiaHR0cHM6Ly9pZC5hdS50ZXN0LnRvbXJhLmNsb3VkL2F1dGgvcmVhbG1zL1RvbXJhQ29ubmVjdFVzZXJzIiwic3ViIjoiZTRiNDhhNmYtNmFmZi00ZjRiLTgwOTktMjk4YjEyZTZhNGZmIiwidHlwIjoiUmVmcmVzaCIsImF6cCI6Im15dG9tcmEtaG90bGluZS10b29sLXVpIiwic2lkIjoiMTRkYmMzNjAtZDRlNC00YTRhLWI5ODktNTM3YmVkYzU4MGJlIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBhY3Igd2ViLW9yaWdpbnMgYmFzaWMgcm9sZXMifQ.QlXMoL_LAdOVj0-3AymFADNzcOeY72w9Oneh-4EXakztwIGHS-w6WkIazywOqX8JoScd8JF1GD0pQSEQpgwoVA',
  token_type: 'Bearer',
  id_token:
    'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJyZjZZMk1JdjhjRER0NHVPay1tVEpfakpSMDdmS2NvSlNhREZqdEd1NzlZIn0.eyJleHAiOjE3NDgzNTAzMDgsImlhdCI6MTc0ODM0ODUwOCwiYXV0aF90aW1lIjoxNzQ4MzQ4MDE0LCJqdGkiOiI0YTBlYWQzYi04YWM4LTQ2MjQtYjY5MC1lYTQ0NDIzYmJkYzMiLCJpc3MiOiJodHRwczovL2lkLmF1LnRlc3QudG9tcmEuY2xvdWQvYXV0aC9yZWFsbXMvVG9tcmFDb25uZWN0VXNlcnMiLCJhdWQiOiJteXRvbXJhLWhvdGxpbmUtdG9vbC11aSIsInN1YiI6ImU0YjQ4YTZmLTZhZmYtNGY0Yi04MDk5LTI5OGIxMmU2YTRmZiIsInR5cCI6IklEIiwiYXpwIjoibXl0b21yYS1ob3RsaW5lLXRvb2wtdWkiLCJub25jZSI6Ijg1OWFiZTQwLTM5NWEtNDIwZC05YTgyLWMxNjNmNGM1MDFmMiIsInNpZCI6IjE0ZGJjMzYwLWQ0ZTQtNGE0YS1iOTg5LTUzN2JlZGM1ODBiZSIsImF0X2hhc2giOiJGTmc3SXhMSHdmcmdIV241RDRnT2NBIiwiYWNyIjoiMCIsImVtYWlsX3ZlcmlmaWVkIjp0cnVlLCJuYW1lIjoiRWxpbiBTdW5kZSBXaWxiZXJnIiwicHJlZmVycmVkX3VzZXJuYW1lIjoiZWxpbi5zdW5kZS53aWxiZXJnQHRvbXJhLmNvbSIsImdpdmVuX25hbWUiOiJFbGluIFN1bmRlIiwiZmFtaWx5X25hbWUiOiJXaWxiZXJnIiwiZW1haWwiOiJlbGluLnN1bmRlLndpbGJlcmdAdG9tcmEuY29tIn0.Gc0BOUNRjm3rbeqJRQ3DfpmFgu3o54pP5OOxLnIe7S05HcduZkABGljHhKhgAtc23WteIDYSnnIPSCm4jSQpZyjIqcUBxOlMa7VKylRPzHwS_spVyvaJpyCDkYvf3qv8CV3u22l_EBJsNqLSblIFQn0Y3PD1sy6_b48tsxb0PbrzIbKxKTrOrkEuijrb2m5rZsYoqd_UVgxv-QmiA17WGuWjfkYbnI0tI5sQNbZbbQ3fuHC-bcfs5w2GPBT3CNQDToJR_5q8Qpaza1t31h0v7l1oyhlMcmANzbFeE-2TktDMIFoAsm6acDpTYLEYdtTKFb9FYJqrzIjE4O20uP1Gfw',
  'not-before-policy': 0,
  session_state: '14dbc360-d4e4-4a4a-b989-537bedc580be',
  scope: 'openid profile email'
}

export const managerNotesResponse = {
  data: [
    {
      id: 249,
      sourceId: '1179c981-5bcb-4613-877b-4cdd658a9d14',
      created: '2022-03-24T12:11:00.609687Z',
      updated: null,
      name: 'Test Testesem',
      email: 'test@tomra.com',
      notes: 'This is a very important manager note'
    }
  ]
}

export const newCharitiesResponse = {
  data: [
    {
      id: '1179c981-5bcb-4613-877b-4cdd658a9d14',
      status: 'NEW',
      organizationName: 'TOMRA SORTING PTY LTD',
      displayName: 'Save the koalas',
      createdAt: '2021-01-18T14:16:17.190752Z',
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN',
      appContext: 'RETURNANDEARN'
    }
  ]
}

export const newCampaignsResponse = {
  data: [
    {
      id: '426ddae4-2c02-4619-a020-aa5069c8d3d7',
      status: 'NEW',
      name: 'Save a Whale',
      startTime: '2022-07-27T08:55:47Z',
      endTime: '2022-12-01T09:55:47Z',
      createdAt: '2022-07-11T09:18:10.437712Z',
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media',
      charitySummary: {
        id: '870a14cf-e2e2-4254-a291-c9855ab396ea',
        status: 'ACTIVE',
        organizationName: 'TOMRA SORTING PTY LTD',
        displayName: 'Bunny Charity',
        createdAt: '2022-07-11T09:07:53.690996Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/870a14cf-e2e2-4254-a291-c9855ab396ea-1657530471619.jpeg',
        campaignRunState: null,
        appContext: 'CDSVICWEST'
      }
    }
  ]
}

export const pendingCharitiesResponse = {
  data: [
    {
      id: 'e13c8469-12cd-4ffa-ae78-303a8e54d824',
      status: 'NEW',
      organizationName: 'TOMRA COLLECTION PTY LTD',
      displayName: 'Organization with changes',
      createdAt: '2022-01-25T13:24:42.801854Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/e13c8469-12cd-4ffa-ae78-303a8e54d824-1643117081921.jpeg',
      campaignRunState: null,
      appContext: 'RETURNANDEARN',
      pendingCharityCreatedAt: '2022-01-25T13:24:42.801854Z'
    }
  ]
}

export const pendingCampaignsResponse = {
  data: [
    {
      id: '9e18d531-48dd-4a96-a958-42aae3c01336',
      status: 'NEW',
      name: 'Campaign with changes',
      startTime: '2022-02-09T18:21:22.811Z',
      endTime: '2023-02-09T18:21:22.811Z',
      createdAt: '2022-01-25T13:25:02.152763Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/9e18d531-48dd-4a96-a958-42aae3c01336-1643117101274.jpeg',
      charitySummary: {
        id: 'e13c8469-12cd-4ffa-ae78-303a8e54d824',
        status: 'NEW',
        organizationName: 'TOMRA SORTING PTY LTD',
        displayName: 'Test',
        createdAt: '2022-01-25T13:24:42.801854Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/e13c8469-12cd-4ffa-ae78-303a8e54d824-1643117081921.jpeg',
        campaignRunState: null,
        appContext: 'RETURNANDEARN'
      },
      pendingCampaignCreatedAt: '2022-01-21T13:24:42.801854Z'
    }
  ]
}

export const promotedCampaignsResponse = {
  data: [
    {
      id: '588d4583-cfee-4dc9-8a00-be29faddfd5b',
      status: 'ACTIVE',
      name: 'Kangaroo Pants',
      startTime: '2020-11-02T00:00:00Z',
      endTime: '2021-02-22T00:00:00Z',
      createdAt: '2020-11-05T14:38:49.796807Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/588d4583-cfee-4dc9-8a00-be29faddfd5b-1608283014495.jpeg',
      charitySummary: {
        id: 'f828800c-5f4f-4fdb-9e10-a2340ffc8338',
        status: 'ACTIVE',
        organizationName: 'Kangaroo Komrades Ltd',
        displayName: 'Kangaroo Komrades',
        createdAt: '2020-10-26T15:20:47.458001Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/f828800c-5f4f-4fdb-9e10-a2340ffc8338-1608283010016.jpeg',
        campaignRunState: null
      }
    },
    {
      id: '4a4e77cf-dab7-432a-949a-7c43bb8ee8ef',
      status: 'ACTIVE',
      name: 'Ugly Cat Face Surgery',
      startTime: '2021-01-02T00:00:00Z',
      endTime: '2021-04-03T00:00:00Z',
      createdAt: '2020-12-18T12:25:02.553003Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/4a4e77cf-dab7-432a-949a-7c43bb8ee8ef-1608294302396.jpeg',
      charitySummary: {
        id: 'f25e5104-59f4-45a0-b118-dbe00f555660',
        status: 'ACTIVE',
        organizationName: 'CATCORP PTY LTD',
        displayName: 'Ugly Cats Inc',
        createdAt: '2020-12-18T12:23:40.169566Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/f25e5104-59f4-45a0-b118-dbe00f555660-1608294220108.jpeg',
        campaignRunState: null
      }
    }
  ]
}

const IncorporationFileAttachment = {
  type: 'IncorporationFile',
  savedAt: '2020-10-26T15:20:12.658439Z',
  savedById: '6988e584-0dad-4714-8a15-24e7470bc5e0',
  savedByEmail: 'charity-test-01@tomra.com',
  contentType: 'application/pdf'
}

const ProofOfBankDetailsAttachment = {
  type: 'ProofOfBankDetails',
  savedAt: '2020-10-26T15:20:12.658439Z',
  savedById: '6988e584-0dad-4714-8a15-24e7470bc5e0',
  savedByEmail: 'charity-test-01@tomra.com',
  contentType: 'application/pdf'
}

const ParentOrganizationLetterAttachment = {
  type: 'ParentOrganizationLetter',
  savedAt: '2020-10-26T15:16:38.148897Z',
  savedById: '6988e584-0dad-4714-8a15-24e7470bc5e0',
  savedByEmail: 'charity-test-01@tomra.com',
  contentType: 'application/pdf'
}

const ABNDocumentAttachment = {
  type: 'ABNDocument',
  savedAt: '2020-10-26T15:16:38.148897Z',
  savedById: '6988e584-0dad-4714-8a15-24e7470bc5e0',
  savedByEmail: 'charity-test-01@tomra.com',
  contentType: 'application/pdf'
}

const StatutoryDeclarationAttachment = {
  type: 'StatutoryDeclaration',
  savedAt: '2020-10-26T15:19:05.870167Z',
  savedById: '6988e584-0dad-4714-8a15-24e7470bc5e0',
  savedByEmail: 'charity-test-01@tomra.com',
  contentType: 'image/jpeg'
}

export const charityByIdResponse = {
  meta: {
    attachments: [
      ProofOfBankDetailsAttachment,
      ABNDocumentAttachment,
      IncorporationFileAttachment,
      ParentOrganizationLetterAttachment,
      StatutoryDeclarationAttachment
    ]
  },
  data: {
    id: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'NEW',
    organization: {
      name: 'The greatest save the koalas organisation ever created',
      organizationAbn: '99',
      appContext: 'RETURNANDEARN',
      registeredState: 'NSW',
      establishedDate: '2016-01-01',
      legalStructure: 'NON_PROFIT_COMPANY',
      geoFootprint: 'NATIONAL',
      incorporationNumber: 'incnum',
      displayName: 'Save the koalas',
      localGroupName: 'local group',
      streetAddress: '1600 Pennsylvania Avenue',
      postCode: '20500',
      benefit: 'ANIMAL_WELFARE',
      description: 'Super charity for the best koala savers ever',
      legalStructureDetails: 'Legal',
      suburb: 'Fjaseby',
      websiteUrl:
        'https://www.pcycnsw.org.au/eastern-suburbs/#:~:text=About%20PCYC%20Eastern%20Suburbs.%20PCYC%20NSW%20is%20a,the%20club%2C%20and%20have%20a%20number%20of%20',
      externalId: null
    },
    bankingData: {
      accountName: 'My super bank account',
      accountBsb: '42',
      accountNumber: '777',
      accountReference: 'My reference',
      dgrStatus: 'UNRESTRICTED'
    },
    primaryContact: {
      firstName: 'Ko',
      lastName: 'Ala',
      position: 'President',
      email: 'koa.la@savekoalas.com.au',
      phone: '+1987654321'
    },
    secondaryContact: {
      firstName: 'Sec',
      lastName: 'Ondary',
      position: 'Manager',
      email: 'sec.ondary@savekoalas.com.au',
      phone: '+123456789'
    },
    updatedAt: '2023-10-20T12:16:07.150518Z',
    updatedBy: 'e4b48a6f-6aff-4f4b-8099-298b12e6a4ff',
    createdAt: '2021-02-03T01:35:28.507554Z',
    administratorUserId: 'de4ca3a0-a06d-40fd-ad0d-3c334f800a1e',
    administratorEmail: 'charity-test-400@tomra.com',
    logoUrl:
      'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media'
  }
}

export const charityAttachmentsResponse = {
  data: [
    IncorporationFileAttachment,
    ProofOfBankDetailsAttachment,
    ParentOrganizationLetterAttachment,
    ABNDocumentAttachment,
    StatutoryDeclarationAttachment
  ]
}

export const charityCampaignRequest = {
  data: [
    {
      id: 'campaign-123',
      status: 'ACTIVE',
      name: 'Help Save Koalas',
      startTime: '2023-01-01T00:00:00.000Z',
      endTime: '2024-12-31T23:59:59.000Z',
      createdAt: '2023-01-01T00:00:00.000Z',
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media',
      charitySummary: {
        id: 'ca657954-4cae-451c-826c-02ba1982e80d',
        status: 'ACTIVE',
        organizationName: 'The greatest save the koalas organisation ever created',
        displayName: 'Save the koalas',
        createdAt: '2021-02-03T01:35:28.507554Z',
        logoUrl:
          'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media',
        campaignRunState: 'RUNNING',
        appContext: 'RETURNANDEARN',
        barcode: '',
        note: ''
      }
    }
  ]
}

export const charityAttachmentRequest = {
  data: []
}

export const campaignByIdResponse = {
  data: {
    campaignId: 'campaign-123',
    charityId: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'ACTIVE',
    name: 'Help Save Koalas',
    description: 'Campaign to save koalas',
    startTime: '2023-01-01T00:00:00.000Z',
    endTime: '2024-12-31T23:59:59.000Z',
    financialTarget: 10000,
    engagementPlan: 'We will engage the community through social media',
    facebookHandle: 'https://facebook.com/savekoalas',
    instagramHandle: 'https://instagram.com/savekoalas',
    twitterHandle: 'https://twitter.com/savekoalas',
    youtubeHandle: 'https://youtube.com/savekoalas',
    linkedinHandle: 'https://linkedin.com/company/savekoalas',
    snapchatHandle: null,
    tiktokHandle: null,
    createdAt: '2023-01-01T00:00:00.000Z'
  }
}

export const pendingCharitiesByIdResponse = {
  data: {
    id: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'PENDING_CHANGE',
    organization: {
      name: 'Updated Koala Organisation Name',
      organizationAbn: '99',
      appContext: 'RETURNANDEARN',
      registeredState: 'NSW',
      establishedDate: '2016-01-01',
      legalStructure: 'NON_PROFIT_COMPANY',
      geoFootprint: 'NATIONAL',
      incorporationNumber: 'incnum',
      displayName: 'Save the koalas',
      localGroupName: 'local group',
      streetAddress: '1600 Pennsylvania Avenue',
      postCode: '20500',
      benefit: 'ANIMAL_WELFARE',
      description: 'Super charity for the best koala savers ever',
      legalStructureDetails: 'Legal',
      suburb: 'Fjaseby',
      websiteUrl: 'https://www.pcycnsw.org.au/eastern-suburbs/',
      externalId: null
    },
    bankingData: {
      accountName: 'My super bank account',
      accountBsb: '42',
      accountNumber: '777',
      accountReference: 'My reference',
      dgrStatus: 'UNRESTRICTED'
    },
    primaryContact: {
      firstName: 'Ko',
      lastName: 'Ala',
      position: 'President',
      email: 'koa.la@savekoalas.com.au',
      phone: '+1987654321'
    },
    secondaryContact: {
      firstName: 'Sec',
      lastName: 'Ondary',
      position: 'Manager',
      email: 'sec.ondary@savekoalas.com.au',
      phone: '+123456789'
    },
    updatedAt: '2023-10-20T12:16:07.150518Z',
    updatedBy: 'e4b48a6f-6aff-4f4b-8099-298b12e6a4ff',
    createdAt: '2021-02-03T01:35:28.507554Z',
    administratorUserId: 'de4ca3a0-a06d-40fd-ad0d-3c334f800a1e',
    administratorEmail: 'charity-test-400@tomra.com',
    logoUrl:
      'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media'
  }
}

export const pendingCampaignByIdResponse = {
  data: {
    id: 'campaign-123',
    charityId: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'PENDING_CHANGE',
    name: 'Updated Campaign Name',
    description: 'Updated campaign description',
    startDate: '2023-01-01',
    endDate: '2024-12-31',
    facebookUrl: 'https://facebook.com/updated',
    instagramUrl: 'https://instagram.com/updated',
    twitterUrl: 'https://twitter.com/updated',
    youtubeUrl: 'https://youtube.com/updated',
    linkedinUrl: 'https://linkedin.com/company/updated',
    createdAt: '2023-01-01T00:00:00Z',
    updatedAt: '2023-01-01T00:00:00Z'
  }
}

export const updatedCharityResponse = {
  data: {
    id: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'ACTIVE',
    organization: {
      name: 'The greatest save the koalas organisation ever created',
      organizationAbn: '99',
      appContext: 'RETURNANDEARN',
      registeredState: 'NSW',
      establishedDate: '2016-01-01',
      legalStructure: 'NON_PROFIT_COMPANY',
      geoFootprint: 'NATIONAL',
      incorporationNumber: 'incnum',
      displayName: 'Save the koalas',
      localGroupName: 'local group',
      streetAddress: '1600 Pennsylvania Avenue',
      postCode: '20500',
      benefit: 'ANIMAL_WELFARE',
      description: 'Super charity for the best koala savers ever',
      legalStructureDetails: 'Legal',
      suburb: 'Fjaseby',
      websiteUrl: 'https://www.pcycnsw.org.au/eastern-suburbs/',
      externalId: null
    },
    bankingData: {
      accountName: 'My super bank account',
      accountBsb: '42',
      accountNumber: '777',
      accountReference: 'My reference',
      dgrStatus: 'UNRESTRICTED'
    },
    primaryContact: {
      firstName: 'Ko',
      lastName: 'Ala',
      position: 'President',
      email: 'koa.la@savekoalas.com.au',
      phone: '+1987654321'
    },
    secondaryContact: {
      firstName: 'Sec',
      lastName: 'Ondary',
      position: 'Manager',
      email: 'sec.ondary@savekoalas.com.au',
      phone: '+123456789'
    },
    updatedAt: '2023-10-20T12:16:07.150518Z',
    updatedBy: 'e4b48a6f-6aff-4f4b-8099-298b12e6a4ff',
    createdAt: '2021-02-03T01:35:28.507554Z',
    administratorUserId: 'de4ca3a0-a06d-40fd-ad0d-3c334f800a1e',
    administratorEmail: 'charity-test-400@tomra.com',
    logoUrl:
      'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media'
  }
}

export const allCharitiesResponse = {
  data: [
    {
      id: '64bf2aeb-493e-4493-b9ae-b5885a24eaac',
      status: 'ACTIVE',
      organization: {
        name: 'GENERALA GOPPERA FONDS BOY SCOUT CHARITY',
        organizationAbn: '95320922197',
        registeredState: 'VIC',
        appContext: 'CDSVICWEST',
        establishedDate: '2021-10-20T10:27:22.076Z',
        legalStructure: 'REGISTERED_SCHOOL',
        legalStructureDetails: '',
        geoFootprint: 'LOCAL',
        incorporationNumber: '',
        localGroupName: '',
        streetAddress: 'Testroad 22',
        postCode: '1234',
        suburb: 'Testurbia',
        displayName: 'Save the Sharks',
        benefit: 'ANIMAL_WELFARE',
        description:
          'Baby Shark, doo-doo, doo-doo, doo-doo\nBaby Shark, doo-doo, doo-doo, doo-doo\nBaby Shark, doo-doo, doo-doo, doo-doo\nBaby Shark',
        websiteUrl: 'www.example.com',
        externalId: 'C2000002380'
      },
      bankingData: {
        accountName: 'TestAccount',
        accountBsb: '123456',
        accountNumber: '1234567',
        dgrStatus: 'NONE'
      },
      primaryContact: {
        firstName: 'Elin',
        lastName: 'Sunde Wilberg',
        position: 'Chief Shark Officer',
        email: 'elin.sunde.wilberg@tomra.com',
        phone: '576315762351762'
      },
      secondaryContact: null,
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2F64bf2aeb-493e-4493-b9ae-b5885a24eaac-1697797785816_400x400?alt=media',
      barcode: 'D2605897364',
      updatedAt: '2023-10-20T10:31:20.360380Z',
      updatedBy: 'fm2qrAlgKocMVe6Dw0iskeVpeg13',
      createdAt: '2023-10-20T10:31:20.360380Z',
      administratorUserId: 'fm2qrAlgKocMVe6Dw0iskeVpeg13',
      administratorEmail: 'elin.sunde.wilberg@tomra.com'
    },
    {
      id: '7b284293-38cd-4321-9120-dddb59da24ef',
      status: 'NEW',
      organization: {
        name: 'Daniel Weissnat DDS',
        organizationAbn: '95320922197',
        registeredState: 'VIC',
        appContext: 'CDSVICWEST',
        establishedDate: '2020-11-23T11:42:14.000Z',
        legalStructure: 'ACNC_CHARITY',
        legalStructureDetails: '',
        geoFootprint: 'LOCAL',
        incorporationNumber: '',
        localGroupName: '',
        streetAddress: 'Drengsrudhagen 2',
        postCode: '1385',
        suburb: '',
        displayName: 'Save the baby Sharks!',
        benefit: 'ANIMAL_WELFARE',
        description:
          'Baby Shark, doo-doo, doo-doo, doo-doo Baby Shark, doo-doo, doo-doo, doo-doo Baby Shark, doo-doo, doo-doo, doo-doo Baby Shark',
        websiteUrl: 'www.example.com',
        externalId: 'C2000002380'
      },
      bankingData: {
        accountName: 'TestAccount',
        accountBsb: '123456',
        accountNumber: '1234567',
        dgrStatus: 'NONE'
      },
      primaryContact: {
        firstName: 'Elin',
        lastName: 'Sunde',
        position: 'Developer',
        email: 'elin.sunde.wilberg@tomra.com',
        phone: ''
      },
      secondaryContact: {
        firstName: 'Mara',
        lastName: 'Alinea',
        position: 'TPM',
        email: 'katherine.mara.alinea@tomra.com',
        phone: '1234567890'
      },
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2F7b284293-38cd-4321-9120-dddb59da24ef-1716464639514_400x400?alt=media',
      barcode: 'D2605925988',
      updatedAt: '2024-05-23T11:44:06.290115Z',
      updatedBy: 'e4b48a6f-6aff-4f4b-8099-298b12e6a4ff',
      createdAt: '2023-11-23T12:06:55.888146Z',
      administratorUserId: 'aec1f508-11d7-4238-bd52-620c1bf064ce',
      administratorEmail: 'katherine.mara.alinea@tomra.com'
    }
  ]
}

export const allCampaignsResponse = {
  data: [
    {
      campaignId: 'bc8eb265-65cf-4007-9e7d-751efcd31057',
      status: 'EXPIRED',
      name: 'Save the saviour',
      description: 'Save the saviour',
      startTime: '2023-12-07T11:56:00Z',
      endTime: '2024-01-06T23:00:00Z',
      createdAt: '2023-11-23T12:20:25.088152Z',
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2F7b284293-38cd-4321-9120-dddb59da24ef-1700741070485_400x400?alt=media',
      charityId: '7b284293-38cd-4321-9120-dddb59da24ef',
      financialTarget: 10000
    }
  ]
}

export const charitySearchResponse = {
  data: [
    {
      id: '45250a16-02b9-4353-bc5b-13b14caa34a2',
      status: 'DISABLED',
      organizationName: 'Shark Aid',
      displayName: 'Test',
      createdAt: '2020-10-12T10:19:21.944444Z',
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN'
    },
    {
      id: '2e29b86a-58ba-41ca-ba8e-d9173a6a86c2',
      status: 'ACTIVE',
      organizationName: 'Rooftop Emergency',
      displayName: 'Rooftop Emergency',
      createdAt: '2020-12-03T07:23:01.333036Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/2e29b86a-58ba-41ca-ba8e-d9173a6a86c2.jpeg',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN'
    },
    {
      id: 'b751d044-cedc-47ae-9d33-8f2b87096c18',
      status: 'ACTIVE',
      organizationName: 'TOMRA SORTING PTY LTD',
      displayName: 'TSH',
      createdAt: '2020-11-05T07:56:59.664661Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/b751d044-cedc-47ae-9d33-8f2b87096c18.png',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN'
    },
    {
      id: 'ef09bd6a-7f78-430f-8b1c-0bf5d4d8cf3e',
      status: 'ACTIVE',
      organizationName: 'TROLL PTY LTD',
      displayName: "Trollz'R'Us",
      createdAt: '2020-12-16T09:23:59.310890Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/ef09bd6a-7f78-430f-8b1c-0bf5d4d8cf3e.png',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN'
    },
    {
      id: '893911ae-786d-4a4a-937b-335008ca77a9',
      status: 'ACTIVE',
      organizationName: 'THE CHRISTMAS COMPANY PTY. LTD.',
      displayName: "Santa's Gift Fund",
      createdAt: '2020-12-18T12:06:59.822363Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/893911ae-786d-4a4a-937b-335008ca77a9-1608293219386.jpeg',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN'
    },
    {
      id: '6a208d5b-da18-4c06-8f0b-2fb318c7ac2e',
      status: 'ACTIVE',
      organizationName: 'Dogcorp Pty Ltd',
      displayName: 'Dog Lovaz',
      createdAt: '2020-12-18T10:12:41.109862Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/6a208d5b-da18-4c06-8f0b-2fb318c7ac2e-1608286360597.png',
      campaignRunState: 'NO_SCHEDULED_CAMPAIGN'
    }
  ]
}

export const campaignSearchResponse = {
  data: [
    {
      id: '426ddae4-2c02-4619-a020-aa5069c8d3d7',
      status: 'NEW',
      name: 'Charity Campaign test',
      startTime: '2022-07-27T08:55:47Z',
      endTime: '2022-12-01T09:55:47Z',
      createdAt: '2022-07-11T09:18:10.437712Z',
      logoUrl:
        'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media',
      charitySummary: {
        id: '870a14cf-e2e2-4254-a291-c9855ab396ea',
        status: 'ACTIVE',
        organizationName: 'TOMRA SORTING PTY LTD',
        displayName: 'Bunny Charity',
        createdAt: '2022-07-11T09:07:53.690996Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/870a14cf-e2e2-4254-a291-c9855ab396ea-1657530471619.jpeg',
        campaignRunState: null
      }
    }
  ]
}

export const reorderPromotedCampaignsResponse = {
  data: [
    {
      id: '4a4e77cf-dab7-432a-949a-7c43bb8ee8ef',
      status: 'ACTIVE',
      name: 'Ugly Cat Face Surgery',
      startTime: '2021-01-02T00:00:00Z',
      endTime: '2021-04-03T00:00:00Z',
      createdAt: '2020-12-18T12:25:02.553003Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/4a4e77cf-dab7-432a-949a-7c43bb8ee8ef-1608294302396.jpeg',
      charitySummary: {
        id: 'f25e5104-59f4-45a0-b118-dbe00f555660',
        status: 'ACTIVE',
        organizationName: 'CATCORP PTY LTD',
        displayName: 'Ugly Cats Inc',
        createdAt: '2020-12-18T12:23:40.169566Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/f25e5104-59f4-45a0-b118-dbe00f555660-1608294220108.jpeg',
        campaignRunState: null
      }
    },
    {
      id: '588d4583-cfee-4dc9-8a00-be29faddfd5b',
      status: 'ACTIVE',
      name: 'Kangaroo Pants',
      startTime: '2020-11-02T00:00:00Z',
      endTime: '2021-02-22T00:00:00Z',
      createdAt: '2020-11-05T14:38:49.796807Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/588d4583-cfee-4dc9-8a00-be29faddfd5b-1608283014495.jpeg',
      charitySummary: {
        id: 'f828800c-5f4f-4fdb-9e10-a2340ffc8338',
        status: 'ACTIVE',
        organizationName: 'Kangaroo Komrades Ltd',
        displayName: 'Kangaroo Komrades',
        createdAt: '2020-10-26T15:20:47.458001Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/f828800c-5f4f-4fdb-9e10-a2340ffc8338-1608283010016.jpeg',
        campaignRunState: null
      }
    }
  ]
}

export const removePromotedCampaignResponse = {
  data: [
    {
      id: '588d4583-cfee-4dc9-8a00-be29faddfd5b',
      status: 'ACTIVE',
      name: 'Kangaroo Pants',
      startTime: '2020-11-02T00:00:00Z',
      endTime: '2021-02-22T00:00:00Z',
      createdAt: '2020-11-05T14:38:49.796807Z',
      logoUrl:
        'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/588d4583-cfee-4dc9-8a00-be29faddfd5b-1608283014495.jpeg',
      charitySummary: {
        id: 'f828800c-5f4f-4fdb-9e10-a2340ffc8338',
        status: 'ACTIVE',
        organizationName: 'Kangaroo Komrades Ltd',
        displayName: 'Kangaroo Komrades',
        createdAt: '2020-10-26T15:20:47.458001Z',
        logoUrl:
          'https://mytomra-charity-files-au-test.s3.ap-southeast-2.amazonaws.com/public/f828800c-5f4f-4fdb-9e10-a2340ffc8338-1608283010016.jpeg',
        campaignRunState: null
      }
    }
  ]
}

export const pendingCharityChangesResponse = {
  meta: {
    attachments: [ProofOfBankDetailsAttachment, ABNDocumentAttachment, IncorporationFileAttachment]
  },
  data: {
    id: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'PENDING_CHANGE',
    organization: {
      name: 'Updated Koala Organisation Name',
      organizationAbn: '99',
      appContext: 'RETURNANDEARN',
      registeredState: 'NSW',
      establishedDate: '2016-01-01',
      legalStructure: 'NON_PROFIT_COMPANY',
      geoFootprint: 'NATIONAL',
      incorporationNumber: 'incnum',
      displayName: 'Save the koalas',
      localGroupName: 'local group',
      streetAddress: '1600 Pennsylvania Avenue',
      postCode: '20500',
      benefit: 'ANIMAL_WELFARE',
      description: 'Super charity for the best koala savers ever',
      legalStructureDetails: 'Legal',
      suburb: 'Fjaseby',
      websiteUrl: 'https://www.pcycnsw.org.au/eastern-suburbs/',
      externalId: null
    },
    bankingData: {
      accountName: 'My super bank account',
      accountBsb: '42',
      accountNumber: '777',
      accountReference: 'My reference',
      dgrStatus: 'UNRESTRICTED'
    },
    primaryContact: {
      firstName: 'Ko',
      lastName: 'Ala',
      position: 'President',
      email: 'koa.la@savekoalas.com.au',
      phone: '+1987654321'
    },
    secondaryContact: {
      firstName: 'Sec',
      lastName: 'Ondary',
      position: 'Manager',
      email: 'sec.ondary@savekoalas.com.au',
      phone: '+123456789'
    },
    updatedAt: '2023-10-20T12:16:07.150518Z',
    updatedBy: 'e4b48a6f-6aff-4f4b-8099-298b12e6a4ff',
    createdAt: '2021-02-03T01:35:28.507554Z',
    administratorUserId: 'de4ca3a0-a06d-40fd-ad0d-3c334f800a1e',
    administratorEmail: 'charity-test-400@tomra.com',
    logoUrl:
      'https://firebasestorage.googleapis.com/v0/b/mytomra-charity-ui-test-17cf.appspot.com/o/uploads%2Fpublic%2Fdfc4c5cf-a412-4dad-af32-61d2080c6552-1693479608587_400x400?alt=media'
  }
}

export const pendingCampaignChangesResponse = {
  data: {
    campaignId: 'campaign-123',
    charityId: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'PENDING_CHANGE',
    name: 'Updated Campaign Name',
    description: 'Updated campaign description',
    startTime: '2023-01-01T00:00:00.000Z',
    endTime: '2024-12-31T23:59:59.000Z',
    financialTarget: 15000,
    engagementPlan: 'Updated engagement plan',
    facebookHandle: 'https://facebook.com/updated',
    instagramHandle: 'https://instagram.com/updated',
    twitterHandle: 'https://twitter.com/updated',
    youtubeHandle: 'https://youtube.com/updated',
    linkedinHandle: 'https://linkedin.com/company/updated',
    snapchatHandle: null,
    tiktokHandle: null,
    createdAt: '2023-01-01T00:00:00.000Z'
  }
}

export const charityCampaignByIdResponse = {
  data: {
    campaignId: 'campaign-456',
    charityId: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'SCHEDULED',
    name: 'Scheduled Koala Campaign',
    description: 'This campaign is scheduled',
    startTime: '2025-01-01T00:00:00.000Z',
    endTime: '2025-12-31T23:59:59.000Z',
    financialTarget: 5000,
    engagementPlan: 'Scheduled campaign engagement plan',
    facebookHandle: 'https://facebook.com/scheduledkoalas',
    instagramHandle: 'https://instagram.com/scheduledkoalas',
    twitterHandle: 'https://twitter.com/scheduledkoalas',
    youtubeHandle: null,
    linkedinHandle: null,
    snapchatHandle: null,
    tiktokHandle: null,
    createdAt: '2024-01-01T00:00:00.000Z'
  }
}

export const pendingCampaignChangesNewEndDatePassedResponse = {
  data: {
    campaignId: 'campaign-123',
    charityId: 'ca657954-4cae-451c-826c-02ba1982e80d',
    status: 'PENDING_CHANGE',
    name: 'Updated Campaign Name',
    description: 'Updated campaign description',
    startTime: '2023-01-01T00:00:00.000Z',
    endTime: '2020-01-01T00:00:00.000Z',
    financialTarget: 15000,
    engagementPlan: 'Updated engagement plan',
    facebookHandle: 'https://facebook.com/updated',
    instagramHandle: 'https://instagram.com/updated',
    twitterHandle: 'https://twitter.com/updated',
    youtubeHandle: 'https://youtube.com/updated',
    linkedinHandle: 'https://linkedin.com/company/updated',
    snapchatHandle: null,
    tiktokHandle: null,
    createdAt: '2023-01-01T00:00:00.000Z'
  }
}
